module.exports = __webpack_public_path__ + "img/parallax-blue.95f9031d.jpg";